var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"wrapper-tooltip"},[_c('svg-icon',{attrs:{"icon-name":_vm.props.icon || 'question',"width":"5","height":"9"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }